import Menu from './Compartido/Menu.jsx';
import TextosTerminos from './Terminos/TextosTerminos.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Terminos = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="5_Terminos"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <TextosTerminos
                lang={props.lang}
                terminos={props.textoterminos}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Terminos;

